import { createFileRoute } from "@tanstack/react-router"

import { EmploymentStep } from "@/features/membership/application/components/employment-step"

export const Route = createFileRoute("/membership/apply/employment")({
  component: EmploymentStep,
})
